import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface LicenseExportSliceState {
  activeExport: { progress: number } | null;
  isPolling: boolean;
  exportProgress: number;
  exportId: string | null;
  exportStatus: string | null;
  completedExportsCount: number;
}

const initialState: LicenseExportSliceState = {
  activeExport: null,
  isPolling: false,
  exportProgress: 0,
  exportId: null,
  exportStatus: null,
  completedExportsCount: 0,
};

const licenseExportSlice = createSlice({
  name: 'aag/licenseExport',
  initialState,
  reducers: {
    setActiveExport: (
      state,
      action: PayloadAction<{ progress: number } | null>
    ) => {
      state.activeExport = action.payload;
    },
    removeActiveExport: (state) => {
      state.activeExport = null;
    },
    setIsPolling: (state, action: PayloadAction<boolean>) => {
      state.isPolling = action.payload;
    },
    setExportProgress: (state, action: PayloadAction<number>) => {
      state.exportProgress = action.payload;
    },
    setExportId: (state, action: PayloadAction<string | null>) => {
      state.exportId = action.payload;
    },
    setExportStatus: (state, action: PayloadAction<string | null>) => {
      state.exportStatus = action.payload;
    },
    setCompletedExportsCount: (state, action: PayloadAction<number>) => {
      state.completedExportsCount = action.payload;
    },
    clearCompletedExport: (state) => {
      state.exportProgress = 0;
      state.exportId = null;
      state.exportStatus = null;
    },
    reset: () => initialState,
  },
});

const { reducer: licenseExportReducer, actions: licenseExportActions } =
  licenseExportSlice;

export { licenseExportActions, licenseExportReducer };
